import React, { useState } from 'react';
import styles from './index.module.css';
import TrackOrderStateGroup from './track-order-state-group';
import { OrderType } from 'models/order.model';
import ContactSupport from 'components/modals/contact-support';
import { SideModal } from '@cokitchen/cokitchen-components';

type Props = {
  order: OrderType;
  showModal: boolean;
  onClose: () => void;
  title: string;
};
const TrackOrder = ({ order, showModal, onClose, title }: Props) => {
  const [showContactSupport, setShowContactSupport] = useState(false);
  return (
    <div className={styles['section']}>
      <SideModal
        closeBtnVariant='side'
        bodyClassName='w-[98vw] sm:w-[450px]'
        showTopNavbar
        isOpen={showModal}
        onRequestClose={onClose}
        title={
          <div>
            <div className='flex justify-between items-center pb-5 mb-5  '>
              <div>
                <p className='text-[#6F7376] text-sm'>Order status</p>
                <p className='text-[24px] font-medium'>{title}</p>
              </div>
              <button
                onClick={() => setShowContactSupport(true)}
                className='text-[#E60A2B] text-xs bg-[#FEF0F2] font-medium rounded-full py-[6px] px-[8px]'>
                Contact support
              </button>
            </div>
            <div className='border-b-[4px] border-[#F7F7F7] mx-[-30px]'></div>
          </div>
        }>
        <div className='mt-[-15px]'>
          <TrackOrderStateGroup expand={true} order={order} />
        </div>
      </SideModal>
      <ContactSupport show={showContactSupport} onClose={() => setShowContactSupport(false)} />
    </div>
  );
};

export default TrackOrder;
